<template>
    <div class="flex items-center font-bold">
        <div class="mr-1">
            {{ text }}
            <span
                class="ml-2 w-5 cursor-pointer inline-block align-middle"
                @click="$emit('click')"
            >
                <img
                    src="@/assets/images/icons/insureKnow.svg"
                    loading="lazy"
                    alt="insureKnow"
                >
            </span>
        </div>
        <div
            v-if="!!price"
            class="ml-auto font-normal"
        >
            {{ price }}
        </div>
    </div>
</template>

<script>
/**
 * 表單-選擇險種的子選項，例如商品自由配>車體損失險>01 車體損失險-甲式(有代碼)
 */
export default {
    name: 'FormInfoInsText',
    props: {
        /** 險種顯示文字 */
        text: {
            type: String,
            default: ''
        },
        /** 保額欄位顯示文字 */
        price: {
            type: String,
            default: ''
        }
    },
    emits: ['click'],
};
</script>